export const blastChillingQueryKeys = {
  all: ['blast-chilling'] as const,
  records: (date: string) => ['blast-chilling', 'records', date] as const,
  calendar: (from: string, to: string) => ['blast-chilling', 'calendar', from, to] as const,
};
